import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { SEOHead } from '../components/SEOHead';
import { Camera } from 'lucide-react';

export default function AppSplash() {
  const [, setLocation] = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLocation('/app/login');
    }, 2000);

    return () => clearTimeout(timer);
  }, [setLocation]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#74A4EA] to-[#64BF49] flex items-center justify-center">
      <SEOHead title="pixcapture.app" description="Professionelle Immobilienfotografie" path="/app/splash" />
      
      <div className="text-center text-white">
        <div className="mb-8 animate-pulse">
          <Camera className="h-24 w-24 mx-auto" />
        </div>
        <h1 className="text-[48px] mb-2">pixcapture.app</h1>
        <p className="text-white/80">Professionelle Immobilienfotografie</p>
      </div>
    </div>
  );
}
